import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { useVocabularyData } from 'app/utils/vocabulary'
import { uniqBy } from 'lodash'
import React, { memo, useContext } from 'react'

import { FooterContext } from './index'
import { PolicyMenuItem } from './PolicyMenuItem'

export const Bottom = memo(function Bottom() {
  const { languageCode, policyMenu, rea, vat, cin } = useContext(
    FooterContext,
  ) as any

  return (
    <Container dial={4} row space="between" wrap>
      <LeftSide dial={4} row wrap>
        <Company>Hotel Spadai Srl</Company>

        {vat ? (
          <Vat>{`${useVocabularyData('vat', languageCode)} ${vat}`}</Vat>
        ) : null}

        {rea ? (
          <Rea>{`${useVocabularyData('rea', languageCode)} ${rea}`}</Rea>
        ) : null}

        {cin ? (
          <Rea>{`${useVocabularyData('cin', languageCode)} ${cin}`}</Rea>
        ) : null}
      </LeftSide>

      <RightSide dial={4} row wrap>
        {policyMenu ? (
          <Policy row wrap>
            {uniqBy(policyMenu, 'title').map((item: any, index) => (
              <PolicyMenuItem key={index} {...item} />
            ))}
          </Policy>
        ) : null}

        <Credits
          aria-label="QNT Hospitality"
          href="https://www.qnt.it"
          rel="noopenet"
          target="_blank"
        >
          {useVocabularyData('credits', languageCode)}
        </Credits>
      </RightSide>
    </Container>
  )
})

const Container = styled(FlexBox)`
  border-top: 0.0625rem solid
    ${({ theme }) => theme.colors.variants.neutralDark4};
  color: ${({ theme }) => theme.colors.variants.neutralLight5};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 0.875rem;
  font-weight: 300;
  line-height: 1.25rem;
  padding: 3rem 8.333vw;

  @media (max-width: 1199px) {
    padding: 1.875rem;
  }
`

const LeftSide = styled(FlexBox)`
  @media (max-width: 1199px) {
    width: 100%;
    justify-content: center;
  }
`

const Company = styled.div``

const Vat = styled.div`
  &:before {
    content: '-';
    margin: 0 0.375rem;
  }
`

const Rea = styled.div`
  &:before {
    content: '-';
    margin: 0 0.375rem;
  }
`

const RightSide = styled(FlexBox)`
  @media (max-width: 1199px) {
    width: 100%;
    justify-content: center;
    margin-top: 1.25rem;
  }
`

const Policy = styled(FlexBox)``

const Credits = styled.a`
  color: ${({ theme }) => theme.colors.variants.neutralLight5};
  margin-left: 1.5rem;
  transition: 0.3s ease-in-out;
  &:hover {
    opacity: 0.4;
  }
`
